import { HoverCard } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { MyContext } from '../../../context';
import { FontIcon } from "office-ui-fabric-react/lib";

export default class HoverCardIncidents extends Component {

    static contextType = MyContext


    plainCardProps = {
        onRenderPlainCard: () => {
            return (
                <MyContext.Consumer>
                    {(context) => (
                        <div>
                            <div style={{ padding: "10px" }}>
                                <div >
                                    {this.props.incidents != null
                                        ? (this.props.incidents
                                            .map((incident, item) => <div key={item}>{incident.caseName}</div>))
                                        : <div>{this.context.getTranslation("common", "loading")}</div>
                                    }
                                </div>
                            </div>
                        </div>
                    )
                    }
                </MyContext.Consumer>
            );
        }
    }


    render() {
        return (
            <HoverCard expandingCardProps={this.expandingCardProps}
                plainCardProps={this.plainCardProps}
                instantOpenOnClick={true}
                type="PlainCard">
                <div>

                    <div style={{ display: "flex", flexDirection: "row" }}>
                        {
                            this.props.incidents != null && this.props.incidents.length > 0 && <div>
                                <FontIcon aria-label="Cases" iconName="ReportWarning" />
                                {` ${this.context.getTranslation("detailContainer", "cases")} (${this.props.incidents.length})`}
                            </div>
                        }
                    </div>

                </div>
            </HoverCard>

        )
    }

}